import { Group, Stack, Text } from '@mantine/core';
import { Variable } from 'components/Variable';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import type { AutomationLog } from 'modules/Settings/Automation/api';
import { capitalize, isString } from 'remeda';

import { ResourceAnchor } from './ResourceAnchor';

type PauseItemProps = {
  log: AutomationLog;
};

export const PauseItem = ({ log }: PauseItemProps) => {
  const { t } = useTranslation();

  if (!isString(log.newValue)) return null;

  return (
    <Stack gap={2}>
      <Group gap={4}>
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.PAUSE.THE_CUSTOMER)}</Text>
        <ResourceAnchor log={log} />
        <Text>{t(i18nKeys.AUTOMATION.HISTORY_PANEL.PAUSE.WAS_PAUSED)}</Text>
        <Variable color="coral">{log.newValue}</Variable>
      </Group>
      <Text size="sm">{capitalize(dayjs().to(log.date))}</Text>
    </Stack>
  );
};
